import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/I18nContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import Coaches from "@/pages/Coaches";
import AgentChat from "@/pages/AgentChat";
import Premium from "@/pages/Premium";
import Admin from "@/pages/Admin";
import Practice from "@/pages/Practice";
import Tests from "@/pages/Tests";
import AssessmentRunner from "@/pages/AssessmentRunner";
import WritingLab from "@/pages/WritingLab";
import SpeakingLab from "@/pages/SpeakingLab";
import ScoreTracking from "@/pages/ScoreTracking";
import Templates from "@/pages/Templates";
import Samples from "@/pages/Samples";
import ExamBank from "@/pages/ExamBank";
import ExamRunner from "@/pages/ExamRunner";
import LevelPractice from "@/pages/LevelPractice";
import ExamProgress from "@/pages/ExamProgress";
import AdminTranscripts from "@/pages/AdminTranscripts";
import AdminMedia from "@/pages/AdminMedia";

function AppLayout({ children, wide = false }) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className={`${wide ? "max-w-7xl" : "max-w-6xl"} mx-auto px-5 py-8`}>{children}</main>
    </div>
  );
}

const P = ({ children, admin, wide }) => (
  <ProtectedRoute adminOnly={admin}><AppLayout wide={wide}>{children}</AppLayout></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<P><Dashboard /></P>} />
            <Route path="/coaches" element={<P><Coaches /></P>} />
            <Route path="/coaches/:agentKey" element={<ProtectedRoute><AgentChat /></ProtectedRoute>} />
            <Route path="/premium" element={<P><Premium /></P>} />
            <Route path="/practice" element={<P><Practice /></P>} />
            <Route path="/practice/levels" element={<P><LevelPractice /></P>} />
            <Route path="/tests" element={<P><Tests /></P>} />
            <Route path="/tests/:id" element={<P><AssessmentRunner /></P>} />
            <Route path="/writing-lab" element={<P><WritingLab /></P>} />
            <Route path="/speaking-lab" element={<P><SpeakingLab /></P>} />
            <Route path="/samples" element={<P><Samples /></P>} />
            <Route path="/exams" element={<P><ExamBank /></P>} />
            <Route path="/exams/progress" element={<P><ExamProgress /></P>} />
            <Route path="/exams/:slug" element={<P><ExamRunner /></P>} />
            <Route path="/score" element={<P><ScoreTracking /></P>} />
            <Route path="/templates" element={<P><Templates /></P>} />
            <Route path="/admin" element={<P admin><Admin /></P>} />
            <Route path="/admin/transcripts" element={<P admin><AdminTranscripts /></P>} />
            <Route path="/admin/media" element={<P admin><AdminMedia /></P>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
